import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import zhCn from 'element-plus/es/locale/lang/zh-cn'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// 由于element-plus版本不同，可能引用路径也不同，该路径版本 "element-plus": "^2.3.8"

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_KeepAlive, null, [
    _createVNode(_component_el_config_provider, { locale: _unref(zhCn) }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }, 8, ["locale"])
  ], 1024))
}
}

})